import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import { CaretDown, CaretUp } from "tabler-icons-react";
import { InputAdornment } from "@mui/material";
import { useTranslation } from "react-i18next";
import MenuItem from "@mui/material/MenuItem";
import { X } from "tabler-icons-react";
import { translate } from "../utils/utils";


const AutocompleteWithPagination = ({
  options,
  isMobile,
  handleSearchText,
  handleSelected,
  value,
  error,
  handleError,
  handleScroll,
  organization,
  width,
}) => {
  const { t } = useTranslation();

  const [openList, setOpenList] = useState(false);

  return (
    <div>
      <TextField
        onFocus={() => setOpenList(true)}
        // onBlur={() => setOpenList(false)}
        autoComplete="off"
        error={error}
        fullWidth
        helperText={error && t("required_field")}
        onChange={(e) => handleSearchText(e.target.value)}
        value={value}
        placeholder={t("select_orga")}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              {value !== "" && (
                <X
                  size={20}
                  strokeWidth={1}
                  onClick={() => {
                    handleSelected({});
                    handleError(true);
                  }}
                  color="#6C6D6F"
                  style={{ cursor: "pointer" }}
                />
              )}
              {openList ? (
                <CaretUp
                  size={20}
                  strokeWidth={1}
                  color="#6C6D6F"
                  onClick={() => setOpenList(false)}
                  style={{ cursor: "pointer" }}
                />
              ) : (
                <CaretDown
                  size={20}
                  strokeWidth={1}
                  color="#6C6D6F"
                  onClick={() => setOpenList(true)}
                  style={{ cursor: "pointer" }}
                />
              )}
            </InputAdornment>
          ),
        }}
      />
      {openList && (
        <div className="liste" style={{ width: width }} onScroll={handleScroll}>
          {options.map((el) => (
            <MenuItem
              sx={{ maxWidth: "1050px" }}
              onClick={() => {
                handleSelected(el);
                setOpenList(false);
                handleError(false);
              }}
            >
              <div
                style={{
                  overflow: "hidden",
                  whiteSpace: "wrap",
                  textOverflow: "ellipsis",
                }}
              >
                {organization ? el.name_A : el[translate("title")]}
              </div>
            </MenuItem>
          ))}
        </div>
      )}
    </div>
  );
};

export default AutocompleteWithPagination;
